export * from './kunden-arts.service';
export * from './kunden-arts.service.module';